module.exports = __webpack_public_path__ + "img/1699427795970.61dd65f1.jpg";